export default __webpack_public_path__ + "static/media/bg-light2@2x.818a261f.jpg";